import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../../../_services/spinner.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  visible = false;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit() {
    this.spinnerService.spinnerVisible$.subscribe(visible => {
      this.visible = visible;
    });
  }
}
